import React, { PureComponent } from 'react'
import classnames from 'classnames'

import './Level.css'

import { OnIcon, InfoIcon } from './Icons'

const ROOT_URL = 'https://widget.vente-en-ligne-esf.com'

export default class Level extends PureComponent {
  touched = code => e => {
    const { onChanged } = this.props
    onChanged(code)
  }

  render() {
    const { name, image, code, comment, selected } = this.props
    const outerClasses = classnames('cm-level--outer', {
      'cm-level--outer__selected': selected
    })

    const infoClasses = classnames('cm-level--info', {
      'cm-level--info__hidden': comment === undefined
    })

    return (
      <div className={outerClasses} onClick={this.touched(code)}>
        <InfoIcon className={infoClasses} />
        <img
          className="cm-level--picto"
          src={`${ROOT_URL}${image}`}
          alt={name}
        />
        <div className="cm-level--text">
          <span>{name}</span>
        </div>
        <div className="cm-level--marker">
          <OnIcon className="cm-level--icon" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Level.js